import { reactive } from 'vue';
import {
    KeyValuePair,
    NavigationItemModel,
    PromotionBannerModel,
    B2CSiteContextModel,
} from '@/types/B2CcontentServerContract';
import { StoreContextSiteContextModel } from '@/types/StoreContextContentServerContract';
import { IBlockLabels } from '@/shared/content/blocks/helpers/block-labels.plugin';
import { B2BSiteContextModel } from '@/types/B2BcontentServerContract';

export const WINDOW_SITE_CONTEXT_PROPERTY = '$$siteContext$$';

export enum GlobalLabels{
    countryPicker = 'countryPicker',
    generic = 'generic',
    product = 'product',
    topBanner = 'topBanner',
    wishlist = 'wishlist',
    navigation = 'navigation',
    search = 'search',
    logInOrSignUp = 'logInOrSignUp',
    byXAndGetYInDiscount = 'byXAndGetYInDiscount',
}

class SiteContextStore {
    private state: B2BSiteContextModel | B2CSiteContextModel | StoreContextSiteContextModel = reactive({
        ...window[WINDOW_SITE_CONTEXT_PROPERTY],
    });

    constructor() {
        if (!window[WINDOW_SITE_CONTEXT_PROPERTY]) {
            throw new Error(`### window.${WINDOW_SITE_CONTEXT_PROPERTY} object should exist ###`);
        }
    }

    public get settings() {
        return this.state;
    }

    public get navigation(): NavigationItemModel[] {
        return this.state?.navigation ?? [] as NavigationItemModel[];
    }

    public get siteHeaders(): KeyValuePair<string, string>[] {
        return this.state?.siteSettings ?? [];
    }

    public get promotionBanner(): PromotionBannerModel | null {
        return this.state?.promotionBanner ?? null;
    }

    public getGlobalLabels(blockName: GlobalLabels): IBlockLabels {
        return this.state?.globalLabels[blockName] ?? {};
    }

    public getLanguages() {
        if ('languages' in this.state) {
            return this.state.languages.map((language) => {
                return language;
            });
        }

        return [];
    }

    public getSearchPageLink() {
        return this.state.searchPageModel.searchPageLink;
    }

    public getQuickLinks() {
        return this.state.searchPageModel.quickLinks;
    }

    public getCountry() {
        return this.state.country;
    }

    public get heroBannerSettings() {
        return this.state.heroBannerSettingsModel;
    }

    public getLocalizedCountry(): string {
        const languages = this.getLanguages();
        if (!languages) {
            return '';
        }

        const currentLanguage = languages.filter((x) => x.current);
        const languageCode = currentLanguage?.[0]?.languageCode;
        if (!languageCode) {
            return '';
        }

        const localizedCountry =
            this.state.country.localizedNames[languageCode];
        if (!localizedCountry) {
            return '';
        }

        return localizedCountry;
    }
}

export default new SiteContextStore();
